import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";

// メールアドレス再登録届参照API
// API仕様書_アカウント管理
import {
  IAPI_ACC005_Request,
  IAPI_ACC005_Response,
} from "../../../type/apiType";

// 申請状況更新API
// API仕様書_申請情報_申請状況更新
import {
  IAPI_APP016_Request,
  IAPI_APP016_Response,
} from "../../../type/apiType";

// メールアドレス再登録届参照API
// API仕様書_アカウント管理
const httpAPI_ACC005 = async (
  param: IAPI_ACC005_Request
): Promise<IAPI_ACC005_Response> => {
  let res = await http.post(ApiUrl.API_ACC005, {
    ...param,
  });
  return res.data;
};

// 申請状況更新API
// API仕様書_申請情報_申請状況更新
const httpAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });
  return res.data;
};

export { httpAPI_ACC005, httpAPI_APP016 };
